/**
 * @generated SignedSource<<56c709038e0c0bdcb9068f12ed963dc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRetainerPeriodInput = {
  id?: string | null;
  projectId?: string | null;
  keepRollovers?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteRetainerPeriodMutation$variables = {
  input: DeleteRetainerPeriodInput;
};
export type deleteRetainerPeriodMutation$data = {
  readonly deleteRetainerPeriod: {
    readonly deletedRetainerPeriodId: string | null;
  } | null;
};
export type deleteRetainerPeriodMutation = {
  variables: deleteRetainerPeriodMutation$variables;
  response: deleteRetainerPeriodMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRetainerPeriodPayload",
    "kind": "LinkedField",
    "name": "deleteRetainerPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedRetainerPeriodId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRetainerPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRetainerPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4b0ad23909d7f57eab3300b48206c427",
    "id": null,
    "metadata": {},
    "name": "deleteRetainerPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRetainerPeriodMutation(\n  $input: DeleteRetainerPeriodInput!\n) {\n  deleteRetainerPeriod(input: $input) {\n    deletedRetainerPeriodId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c362ce68899dfa6fb14ec688d092b7be";

export default node;
